<template>
  <div class="status-bar">
    <span v-if="mouseBoard">{{ mouseBoard.x }}" × {{ mouseBoard.y }}"</span>
    <span v-else>&nbsp;</span>
    <span class="element-counts">
      Obj: {{ map.objectives.length }} | Terrain: {{ map.terrain.length }} | Zones:
      {{ map.zones.length }} | Labels: {{ (map.labels ?? []).length }} | Arrows:
      {{ (map.arrows ?? []).length }}
    </span>
  </div>
</template>

<script setup lang="ts">
import type { IBattleplanMap } from '@scrolldex/shared';

defineProps<{
  map: IBattleplanMap;
  mouseBoard: { x: number; y: number } | null;
}>();
</script>

<style scoped>
.status-bar {
  display: flex;
  justify-content: space-between;
  font-size: var(--st-text-xs);
  color: var(--st-text-muted);
  padding: 0 var(--st-space-1);
}

.element-counts {
  color: var(--st-text-subtle);
}
</style>
